module.exports = __webpack_public_path__ + "img/l2.18888975.jpg";